import { render, staticRenderFns } from "./PensionMap.vue?vue&type=template&id=216247fd&"
import script from "./PensionMap.vue?vue&type=script&lang=js&"
export * from "./PensionMap.vue?vue&type=script&lang=js&"
import style0 from "./PensionMap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports